export const EVIDENTLY_PROJECT = 'red-app'

export type FeatureValue = string | number | boolean

export enum FeatureName {
  WEB_SUBSCRIPTION = 'web_subscription',
  WEB_REDSKY_SEARCH = 'web_redsky_search',
  WEB_BILT = 'web_bilt',
  WEB_REWARDS_LINK_EXPERIMENT = 'web_rewards_link_experiment',
  CC_CTA_EXPERIMENT = 'web_cc_cta_experiment',
  CC_HUB_VARIANTS = 'web_cc_hub_variants',
  WEB_DY_INTEGRATION = 'web_dy_integration',
  UDAL_FLOW = 'web_udal_flow',
  WEB_USCC_PREQUAL = 'web_uscc_prequal',
}

export interface Feature {
  entityId: string
  value: {
    [key in FeatureValueType]: FeatureValue
  }
  variation: string
  name: FeatureName
}

export interface FeaturesResponse {
  features: Feature[]
}

export interface FeaturesState {
  features: Feature[]
  errorMessage: string
  isLoading: boolean
}

export enum FeatureValueType {
  BOOLEAN_VALUE = 'boolValue',
  STRING_VALUE = 'stringValue',
  DOUBLE_VALUE = 'doubleValue',
  LONG_VALUE = 'longValue',
}
